export default __webpack_public_path__ + "static/media/Group9190.427d088a.svg";